import React from 'react';
import clsx from 'clsx';
import { FieldWrapper } from './FieldWrapper';

export const PhoneInputField = ({ className, caption, label, registration, error, onChange }) => {
  return (
    <FieldWrapper label={label} error={error}>
      <div
        className={clsx(
          'flex items-center gap-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md px-3 py-2',
          className
        )}
      >
        <div className="text-sm text-gray-700 dark:text-gray-200 font-medium">+256</div>
        <input
          type="tel"
          maxLength={9}
          onChange={onChange}
          {...registration}
          className="flex-1 bg-transparent focus:outline-none text-sm placeholder-gray-400"
          placeholder="7XX XXX XXX"
        />
      </div>
      {caption && <div className="text-xs text-gray-500 mt-1">{caption}</div>}
      {error?.message && <div className="text-xs text-red-600 mt-1">{error.message}</div>}
    </FieldWrapper>
  );
};
